import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/note.tsx
var Note = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M20.25 11V11.75C20.25 12.8546 19.3546 13.75 18.25 13.75H15.75C14.6454 13.75 13.75 14.6454 13.75 15.75V18.25C13.75 19.3546 12.8546 20.25 11.75 20.25H11M5.75 3.75H18.25C19.3546 3.75 20.25 4.64543 20.25 5.75V13.7497C20.25 14.2801 20.0393 14.7888 19.6642 15.1639L15.1639 19.6642C14.7888 20.0393 14.2801 20.25 13.7497 20.25H5.75C4.64543 20.25 3.75 19.3546 3.75 18.25V5.75C3.75 4.64543 4.64543 3.75 5.75 3.75Z",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3 5.75C3 4.23122 4.23122 3 5.75 3H18.25C19.7688 3 21 4.23122 21 5.75V13.7497C21 14.479 20.7103 15.1785 20.1945 15.6942L15.6942 20.1945C15.1785 20.7103 14.479 21 13.7497 21H5.75C4.23122 21 3 19.7688 3 18.25V5.75ZM11.75 19.5C12.4404 19.5 13 18.9404 13 18.25V15.75C13 14.2312 14.2312 13 15.75 13H18.25C18.9404 13 19.5 12.4404 19.5 11.75V5.75C19.5 5.05964 18.9404 4.5 18.25 4.5H5.75C5.05964 4.5 4.5 5.05964 4.5 5.75V18.25C4.5 18.9404 5.05964 19.5 5.75 19.5H11.75Z",
		fill: "currentColor"
	})
});
//#endregion
export { Note };
